/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Insert_Transcript_Aria_LabelInputs */

const en_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert new transcript event`)
};

const fr_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un nouvel evenement de transcription`)
};

const de_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Transkriptereignis einfügen`)
};

const it_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci nuovo evento di trascrizione`)
};

const ru_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить новое событие транскрипции`)
};

const es_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar nuevo evento de transcripción`)
};

const zh_cn2_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入新的转录事件`)
};

const ja_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいトランスクリプトイベントを挿入`)
};

const hi_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया ट्रांसक्रिप्ट इवेंट डालें`)
};

const pt_pt2_event_insert_transcript_aria_label = /** @type {(inputs: Event_Insert_Transcript_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir novo evento de transcrição`)
};

/**
* | output |
* | --- |
* | "Insert new transcript event" |
*
* @param {Event_Insert_Transcript_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_insert_transcript_aria_label = /** @type {((inputs?: Event_Insert_Transcript_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Insert_Transcript_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_insert_transcript_aria_label(inputs)
	if (locale === "de") return de_event_insert_transcript_aria_label(inputs)
	if (locale === "it") return it_event_insert_transcript_aria_label(inputs)
	if (locale === "ru") return ru_event_insert_transcript_aria_label(inputs)
	if (locale === "es") return es_event_insert_transcript_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_insert_transcript_aria_label(inputs)
	if (locale === "ja") return ja_event_insert_transcript_aria_label(inputs)
	if (locale === "hi") return hi_event_insert_transcript_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_insert_transcript_aria_label(inputs)
	return en_event_insert_transcript_aria_label(inputs)
});